import React from 'react';

export default function ExpandArrowIcon({
  className,
  onClick,
  fill,
}: {
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  fill?: string;
}) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill={fill || '#6C757D'}
    >
      <path d="M5.51762 6.21551L8.95968 3.56672C9.0254 3.51631 9.07753 3.45642 9.11311 3.39048C9.14868 3.32454 9.16699 3.25385 9.16699 3.18245C9.16699 3.11105 9.14868 3.04036 9.11311 2.97442C9.07753 2.90847 9.0254 2.84859 8.95968 2.79818C8.82559 2.6959 8.64443 2.63852 8.45562 2.63852C8.26682 2.63852 8.08566 2.6959 7.95156 2.79818L5.70134 4.52376L5.49999 4.71753C5.49999 4.71753 5.18773 4.95432 5.00033 4.95432C4.81292 4.95432 4.50066 4.71754 4.50066 4.71754L4.28809 4.52376L2.05514 2.79818C1.99053 2.74469 1.91256 2.70179 1.82589 2.67205C1.73922 2.6423 1.64564 2.62633 1.55076 2.62508C1.45588 2.62383 1.36164 2.63734 1.2737 2.66479C1.18576 2.69224 1.10593 2.73306 1.03899 2.78482C0.972045 2.83658 0.919368 2.89821 0.884114 2.96601C0.848861 3.03381 0.831757 3.10639 0.833826 3.1794C0.835895 3.25241 0.857096 3.32435 0.896157 3.3909C0.935219 3.45745 0.991338 3.51725 1.06115 3.56672L4.50479 6.21551C4.63988 6.31772 4.82175 6.375 5.0112 6.375C5.20066 6.375 5.38253 6.31772 5.51762 6.21551Z" />
    </svg>
  );
}
